import { Box, Grid, Typography, Hidden, IconButton, CardMedia } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useHistory } from 'react-router';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { Gridstyles } from '../ApplicationDetails';
import { useDispatch, useSelector } from 'react-redux';
import { KeyValue } from '../ApplicationDetails/InvestorWithoutPan/contributor';
import {
  AuthorisedSignatories,
  RmsType,
  SubDistributorListType,
} from '../../redux-store/types/api-types';
import {
  getAuthorisedSignatoryById,
  getDistributorRMbyId,
  getRMById,
} from '../../redux-store/actions/userManagement';
import { Location } from 'history';
import { RootStateType } from '../../redux-store/reducers';
import { IsCompanyDistributor } from '../../utils/utilityFunctions';
import Loader from '../../utils/Loader';

export default function AuthorisedSignatoryDetails({
  location,
}: {
  location: Location<{ authorisedSignatoryId: number }>;
}): JSX.Element {
  const { authorisedSignatoryId: id } = location.state || { authorisedSignatoryId: null };
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [authorisedSignatoryDetails, setAuthorisedSignatoryDetails] =
    useState<AuthorisedSignatories>();
  const { role = '', dataValues = {} } = useSelector((store: RootStateType) => store.auth);
  const { type } = dataValues;

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        setLoading(true);
        if (id) {
          const getAuthorisedSignatoryDetails = (await dispatch(
            getAuthorisedSignatoryById(id)
          )) as unknown as AuthorisedSignatories;
          setAuthorisedSignatoryDetails(getAuthorisedSignatoryDetails);
        }
        if (!isComponentActive) {
          return;
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, []);

  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
          py: { xs: 2, sm: 5 },
          px: { xs: 0, sm: 5 },
          mt: { xs: 2, sm: 5 },
        }}>
        <Hidden smUp={true}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              sx={{ height: 'fit-content', p: 0 }}
              onClick={() =>
                history.push('authorised-signatory', {
                  distributorId: authorisedSignatoryDetails?.distributorId,
                })
              }>
              <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
            </IconButton>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
              }}>
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              my: 2,
              py: 2,
              pl: { xs: 3, sm: 0 },
              color: 'primary.main',
              bgcolor: 'rgba(238, 244, 251, 0.5)',
            }}>
            <PersonOutlineOutlinedIcon fontSize="large" />
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                pl: 1,
              }}>
              User Management
            </Typography>
          </Box>
        </Hidden>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Hidden only="xs">
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                onClick={() =>
                  history.push('authorised-signatory', {
                    distributorId: authorisedSignatoryDetails?.distributorId,
                  })
                }>
                <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
              </IconButton>
            </Hidden>
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 600,
                color: '#1C2D47',
                pl: { xs: 2, sm: 0 },
              }}>
              Authorised Signatories
            </Typography>
          </Box>
          {IsCompanyDistributor(role, type) && (
            <IconButton>
              <CardMedia
                component="img"
                src="/images/edit-icon-outlined.svg"
                alt="Edit Icon"
                sx={{ width: 'unset' }}
                onClick={() =>
                  history.push('edit-authorised-signatory', {
                    authorisedSignatoryId: authorisedSignatoryDetails?.id,
                  })
                }
              />
            </IconButton>
          )}
        </Box>
        {isLoading ? (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              bgcolor: 'white',
              zIndex: 9999, // Ensures it's above all other content
            }}>
            <Loader size={60} speed={2} />
          </Box>
        ) : (
          authorisedSignatoryDetails && (
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 }, pt: 1 }}>
              <React.Fragment>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={'Name'}
                      description={authorisedSignatoryDetails.user.firstName}
                    />
                    <KeyValue
                      title={'Email Id'}
                      description={authorisedSignatoryDetails.user.email}
                    />
                    <KeyValue
                      title={'Mobile Number'}
                      description={
                        authorisedSignatoryDetails.user?.countryCode
                          ? authorisedSignatoryDetails.user?.countryCode +
                            '-' +
                            authorisedSignatoryDetails.user?.phone
                          : authorisedSignatoryDetails.user.phone
                      }
                    />
                    <KeyValue
                      title={'Employee Code'}
                      description={authorisedSignatoryDetails.empCode}
                    />
                    <KeyValue
                      title={'Pan/Tax Id'}
                      description={authorisedSignatoryDetails.panNumber}
                    />
                    <KeyValue title={'Pincode'} description={authorisedSignatoryDetails.pincode} />
                    <KeyValue
                      title={'Building Number'}
                      description={authorisedSignatoryDetails.buildingNo}
                    />
                    <KeyValue
                      title={'Street Name'}
                      description={authorisedSignatoryDetails.streetName}
                    />
                    <KeyValue title={'State'} description={authorisedSignatoryDetails.state} />
                    <KeyValue title={'City'} description={authorisedSignatoryDetails.city} />
                    <KeyValue title={'Country'} description={authorisedSignatoryDetails.country} />
                  </Grid>
                </Gridstyles>
              </React.Fragment>
            </Grid>
          )
        )}
      </Box>
    </>
  );
}
